import { Injectable } from '@angular/core';
import { Division } from '../shared/enums';
import { DivisionKey } from './division.config.interface';
import { divisionConfig } from './division.config';

@Injectable({
  providedIn: 'root',
})
export class DivisionService {
  public getConfigEntry(key: DivisionKey, division: Division): string {
    return divisionConfig[key][division];
  }
}
